import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetOneVolunteerCommunityWork = createAsyncThunk(
  "GetOneVolunteerCommunityWork/GetOneVolunteerCommunityWork",
  async (parameters, { rejectWithValue }) => {
    try {
     
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/WQ_NT_VC_VolunteerCommunityWork/GetWQ_NT_VC_VolunteerCommunityWorkById",
        parameters
      );

      // Extract data from the response object
      const data = response.data; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const DeleteVolunteerCommunityWork = createAsyncThunk(
  "DeleteVolunteerCommunityWork/DeleteVolunteerCommunityWork",
  async (parameters, { rejectWithValue }) => {
    try {
    
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/WQ_NT_VC_VolunteerCommunityWork/DeleteWQ_NT_VC_VolunteerCommunityWork",
        parameters
      );

      // Extract data from the response object
      const data = response.data; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateVolunteerCommunityWork = createAsyncThunk(
  "UpdateVolunteerCommunityWork/UpdateVolunteerCommunityWork",
  async (parameters, { rejectWithValue }) => {
    try {
   
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/WQ_NT_VC_VolunteerCommunityWork/UpdateWQ_NT_VC_VolunteerCommunityWork",
        parameters
      );

      // Extract data from the response object
      const data = response.data; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AddVolunteerCommunityWork = createAsyncThunk(
  "AddVolunteerCommunityWork/AddVolunteerCommunityWork",
  async (parameters, { rejectWithValue }) => {
    try {
    


      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/WQ_NT_VC_VolunteerCommunityWork/AddWQ_NT_VC_VolunteerCommunityWork",
        parameters
      );

      // Extract data from the response object
      const data = response.data; // Assuming response has a "data" field
      console.log(data, "addJobOpportun");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const VolunteerCommunityWork = createSlice({
  name: "VolunteerCommunityWork",
  initialState: {
    VolunteerCommunityWork: {},
    loadingVolunteerCommunityWork: false,
    errorVolunteerCommunityWork: null,

    AddVolunteerCommunityWork: {},
    loadingAddVolunteerCommunityWork: false,
    errorAddVolunteerCommunityWork: null,

    UpdateVolunteerCommunityWork: {},
    loadingUpdateVolunteerCommunityWork: false,
    errorUpdateVolunteerCommunityWork: null,

    DeleteVolunteerCommunityWork: {},
    loadingDeleteVolunteerCommunityWork: false,
    errorDeleteVolunteerCommunityWork: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetOneVolunteerCommunityWork.pending, (state, action) => {
        state.loadingVolunteerCommunityWork = true;
        state.VolunteerCommunityWork = action.payload;
        state.errorVolunteerCommunityWork = null;
      })
      .addCase(GetOneVolunteerCommunityWork.fulfilled, (state, action) => {
        state.loadingVolunteerCommunityWork = false;
        state.VolunteerCommunityWork = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetOneVolunteerCommunityWork.rejected, (state, action) => {
        state.loadingVolunteerCommunityWork = false;
        state.errorVolunteerCommunityWork = action.payload;
      })

      .addCase(DeleteVolunteerCommunityWork.pending, (state, action) => {
        state.loadingDeleteVolunteerCommunityWork = true;
        state.DeleteVolunteerCommunityWork = action.payload;
        state.errorDeleteVolunteerCommunityWork = null;
      })
      .addCase(DeleteVolunteerCommunityWork.fulfilled, (state, action) => {
        state.loadingDeleteVolunteerCommunityWork = false;
        state.DeleteVolunteerCommunityWork = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeleteVolunteerCommunityWork.rejected, (state, action) => {
        state.loadingDeleteVolunteerCommunityWork = false;
        state.errorDeleteVolunteerCommunityWork = action.payload;
      })

      .addCase(UpdateVolunteerCommunityWork.pending, (state, action) => {
        state.loadingUpdateVolunteerCommunityWork = true;
        state.UpdateVolunteerCommunityWork = action.payload;
        state.errorUpdateVolunteerCommunityWork = null;
      })
      .addCase(UpdateVolunteerCommunityWork.fulfilled, (state, action) => {
        state.loadingUpdateVolunteerCommunityWork = false;
        state.UpdateVolunteerCommunityWork = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdateVolunteerCommunityWork.rejected, (state, action) => {
        state.loadingUpdateVolunteerCommunityWork = false;
        state.errorUpdateVolunteerCommunityWork = action.payload;
      })

      .addCase(AddVolunteerCommunityWork.pending, (state, action) => {
        state.loadingAddVolunteerCommunityWork = true;
        state.AddVolunteerCommunityWork = action.payload;
        state.errorAddVolunteerCommunityWork = null;
      })
      .addCase(AddVolunteerCommunityWork.fulfilled, (state, action) => {
        state.loadingAddVolunteerCommunityWork = false;
        state.AddVolunteerCommunityWork = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddVolunteerCommunityWork.rejected, (state, action) => {
        state.loadingAddVolunteerCommunityWork = false;
        state.errorAddVolunteerCommunityWork = action.payload;
      });
  },
});

export default VolunteerCommunityWork.reducer;
